import { Suspense, useContext } from 'react';
import { Button } from '@givebutter/primitives/button';
import { ClearFiltersButton } from 'components/filter/ClearFiltersButton';
import { Filter } from 'components/filter/filters-next/Filter';
import { FilterGroupProvider } from 'components/filter/filters-next/FilterGroupContext';
import { FilterListItem } from 'components/filter/filters-next/FilterListItem';
import {
    FilterProvider,
    FilterProviderContext,
} from 'components/filter/filters-next/FilterProvider';
import { QuickFiltersBar } from 'components/filter/filters-next/QuickFiltersBar';
import { useFiltersByKey } from 'components/filter/filters-next/useFiltersByKey';
import { getColumnFilterKey } from 'components/filter/filters-next/util';
import { TableContext } from 'components/table/TableContext';
import { getTableResourceFromReportResource } from 'components/table/util';
import { useReportSchemas } from 'customHooks/useReportSchemas';

const TableFilters = () => {
    const { table } = useContext(TableContext);
    const { resource } = useContext(FilterProviderContext);
    const { data: schemas } = useReportSchemas();
    const { filterGroups } = useFiltersByKey('tableFilters');
    const currentEditingColumn = table.getState().currentlyEditingColumn;
    const schema = schemas.find(
        schema => getTableResourceFromReportResource(schema.resource) === resource,
    );
    const columns = schema?.schema.columns ?? [];
    const currentlyEditingColumnFromSchema = columns.find(
        col => col.name === currentEditingColumn?.id,
    );

    if (!schema || !currentEditingColumn || !currentlyEditingColumnFromSchema) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <FilterProvider resource={'tableFilters'} cacheKey={'tableFilters'}>
                <div className={'flex flex-col gap-2 p-4'}>
                    <p className={'text-sm font-medium'}>
                        Filter '{currentlyEditingColumnFromSchema.label}'
                    </p>
                    <FilterGroupProvider showInnerOperator={false} showOuterOperator={false}>
                        <div className={'flex flex-wrap gap-1.5'}>
                            <QuickFiltersBar />
                            <Filter
                                addGroup={false}
                                resource={'tableFilters'}
                                cacheKey={'tableFilters'}
                                dynamicFilters={{
                                    tableColumn:
                                        currentlyEditingColumnFromSchema.column_filters.map(
                                            filter => (
                                                <FilterListItem
                                                    key={filter.type}
                                                    serverKey={getColumnFilterKey(
                                                        currentEditingColumn.id,
                                                        filter.type,
                                                        schema.resource,
                                                    )}
                                                    isLegacy={false}
                                                />
                                            ),
                                        ),
                                }}
                            />
                            <ClearFiltersButton />
                        </div>
                    </FilterGroupProvider>
                    <div className={'flex justify-end gap-2'}>
                        <Button
                            size={'sm'}
                            variant={'outline'}
                            color={'neutral'}
                            onClick={() => table.updateCurrentlyEditingColumn()}
                        >
                            Cancel
                        </Button>
                        <Button
                            size={'sm'}
                            variant={'outline'}
                            color={'neutral'}
                            onClick={() => {
                                table.updateCurrentlyEditingColumn();
                                currentEditingColumn.updateGivebutterColumnFilters(filterGroups);
                            }}
                        >
                            Save
                        </Button>
                    </div>
                </div>
            </FilterProvider>
        </Suspense>
    );
};

export { TableFilters };
